import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import type {ReportURLParams} from '../../../reports/report-types';

import {GraduatedFilter} from '../../entity-lists/graduated-filter';
import type {Option} from '../../entity-lists/graduated-filter';

type Props = {
    audienceId: string;
    filters: FilterObject[];
    urlParams: ReportURLParams<'contacts'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
};

export function AudienceMemberStatusFilter(props: Props) {
    const defaultOption = React.useMemo(() => {
        return {value: {audiences: props.audienceId}, label: 'All members'};
    }, [props.audienceId]);

    const options = React.useMemo(() => {
        return [
            defaultOption,
            {
                value: {
                    subscribedAudiences: props.audienceId,
                },
                label: 'Email subscribers only',
                additionalFilters: [
                    {
                        marketingStatus: {data: [{data: '0', isNot: 'false'}]},
                    },
                ],
            },
            {
                value: {unsubscribedAudiences: props.audienceId},
                label: 'Just unsubscribed members',
            },
            {value: {bouncedEditions: {data: [{data: '-', isNot: 'true'}]}}, label: 'Bouncing'},
            {value: {email: '-'}, label: 'No email address'},
            ...(NutClientConfig.hasSmsAudiencesFF
                ? [{value: {phone: '-'}, label: 'No phone number'}]
                : []),
        ];
    }, [props.audienceId, defaultOption]);

    const optionKeys = React.useMemo(() => {
        return options.map((option) => {
            return Object.keys(option.value)[0];
        });
    }, [options]);

    const activeFilterKey = props.filters
        .map((filterObj) => {
            return Object.keys(filterObj)[0];
        })
        .find((filterKey) => {
            return filterKey !== 'audiences' && optionKeys.includes(filterKey);
        });

    return (
        <GraduatedFilter
            {...props}
            getNewFilters={(option: Option) => {
                return (
                    props.filters
                        .filter((filterObj) => {
                            return (
                                // @ts-expect-error
                                !Object.prototype.hasOwnProperty.call(filterObj, activeFilterKey) &&
                                !Object.prototype.hasOwnProperty.call(filterObj, 'marketingStatus')
                            );
                        })
                        .concat(option.value)
                        // @ts-expect-error
                        .concat(option.additionalFilters || [])
                );
            }}
            activeFilterKey={activeFilterKey}
            defaultOption={defaultOption}
            options={options}
        />
    );
}
